import { Pipe, PipeTransform } from '@angular/core';

import { modosEnviosBoletos } from '../cliente-modo-envio-boleto';

@Pipe({
    name: 'clienteModoEnvioBoleto'
})
export class ClienteModoEnvioBoletoPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return 'Não Informado';
        }

        const index = modosEnviosBoletos.findIndex(modo => modo.id === value);
        if (index > -1) {
            return modosEnviosBoletos[index].nome;
        }
        return '';
    }
}
